<template>
  <div class="row text-center justify-content-center wide-width">
    <div class="col-md-12">
      <object class="logo" height="128" width="128" type="image/svg+xml" data="images/email.svg" alt="Closed">
        <img src="images/close.svg" alt="Closed" />
      </object>
      <h1>Enter your passcode</h1>
      <p class="text-muted text-center text-intro">We've sent a one-time passcode to your email. This passcode will expire
        in 10 minutes.</p>
      <form class="form-signin" :class="{ 'invalid': shakeForm }" name="signin" role="form">
        <section class="pin-container">
          <VOtpInput v-model:value="code" input-classes="otp-input" separator="" :should-auto-focus="true" />
        </section>
        <button @click.prevent="verifyEmailCode" type="submit" class="btn-verify btn btn-primary mb-4"
          :disabled="isVerifyButtonDisabled">Verify</button>
      </form>
      <div v-if="isResendCodeEnabled"><a href="#" @click.prevent="resendVerificationCode" class="btn-link"
          :class="{ disabled: !isResendCodeEnabled }">Request new passcode</a></div>
      <div v-else class="d-flex align-items-center justify-content-center">
        <p class="text-muted text-intro">You will be able to request new code after</p>
        <countdown :transform="transform" :time="intervalForResendCode">
          <template v-slot="props">
            <h5 class="card-title mb-3 ml-2"><span class="badge badge-pill badge-primary">{{ props.minutes }}:{{
              props.seconds }}</span></h5>
          </template>
        </countdown>
      </div>
    </div>
  </div>
</template>

<script>
import DataService from '../services/DataService';
import VOtpInput from "vue3-otp-input";
const ds = DataService.getInstance();

export default {
  name: "VerificationEmail",
  components: {
    VOtpInput
  },
  data () {
    return {
      user: null,
      email: '',
      isSending: false,
      isVerifying: false,
      shakeForm: false,
      code: '',
      isResendCodeEnabled: true,
      intervalForResendCode: 120000,
    }
  },
  created () {
    this.user = Parse.User.current();
    this.email = this.user ? this.user.get("email") : ""
  },
  mounted () {
    this.resendVerificationCode();
  },
  methods: {
    async resendVerificationCode () {
      try {
        this.isSending = true;
        await ds.resendVerificationCode();
        this.isResendCodeEnabled = false;
        // Enable it again after 2 minutes
        setInterval(() => {
          this.isResendCodeEnabled = true;
        }, this.intervalForResendCode);
      } catch (err) {
        this.$bvToast.toast(err.message || err, {
          variant: "danger"
        });
      }
      this.isSending = false;
    },

    async verifyEmailCode () {
      try {
        this.isVerifying = true;
        this.shakeForm = false;
        await ds.verifyEmailVerificationCode(this.code);
        location.reload();
      } catch (err) {
        this.$bvToast.toast(err.message || err, {
          variant: "danger"
        });
        this.shakeForm = true;
      }
      this.isVerifying = false;
    },
    transform (props) {
      Object.entries(props).forEach(([key, value]) => {
        // Adds leading zero
        const digits = value < 10 ? `0${value}` : value;
        props[key] = `${digits}`;
      });
      return props;
    },
  },
  computed: {
    isVerifyButtonDisabled () {
      return !(this.code && this.code.length >= 4);
    }
  }
}
</script>

<style>
.btn-verify {
  width: 240px;
}

.pin-container {
  padding: 3rem 0;
  display: flex;
  justify-content: center;
}

.otp-input {
  width: 70px;
  height: 70px;
  padding: 2px;
  margin: 0 3px;
  font-size: 30px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
}
</style>